import React, { memo, useMemo } from 'react';
import * as styles from './LinkCardV2.module.scss';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import RedNumberText from '../../RedNumberText/RedNumberText';
import LinkDisclaimer from '../../LinkDisclaimer/LinkDisclaimer';
import { useLinkCard } from '../hooks/useLinkCard';

const LinkCardV2 = ({ linkData, disableDeeplinks = false, creatorName }) => {
  const cardBackgroundImage = useMemo(
    () => getImage(linkData.backgroundImage),
    [linkData.backgroundImage]
  );

  const {
    isDisclaimerVisible,
    isInstagram,
    didNavigationSilentBlock,
    closeDisclaimer,
    platformIcon,
    CardWrapper,
  } = useLinkCard({
    ...linkData,
    url: linkData.link,
    creatorName,
    customIconClassName: styles.customLinkIcon,
    disableDeeplinks,
  });

  const {
    platformTitle,
    link,
    backgroundColor,
    backgroundImage,
    withSensitiveLinkHoldToOpen,
  } = linkData;

  return (
    <CardWrapper
      buttonClassName={styles.linkButton}
      linkClassName={styles.linkCardContainer}
    >
      <div className={styles.linkCard} style={{ backgroundColor }}>
        {backgroundImage && (
          <div className={styles.linkCardBackground}>
            <GatsbyImage
              image={cardBackgroundImage}
              alt="Link Background image"
            />
          </div>
        )}

        {isDisclaimerVisible && (
          <LinkDisclaimer
            url={link}
            disableDeeplinks={disableDeeplinks}
            showExternalBrowserInstructions={
              !disableDeeplinks || didNavigationSilentBlock
            }
            creatorName={creatorName}
            onClose={closeDisclaimer}
            withSensitiveLinkHoldToOpen={withSensitiveLinkHoldToOpen}
            v2
          />
        )}

        {(isInstagram || !isDisclaimerVisible) && (
          <div className={styles.linkCardContent}>
            <div className={styles.linkCardIcon}>{platformIcon}</div>

            <p className={styles.linkCardTitle}>
              <RedNumberText {...platformTitle} />
            </p>
          </div>
        )}
      </div>
    </CardWrapper>
  );
};

export default memo(LinkCardV2);
